import { List } from "immutable";

import {
  OUTLINE_DEFAULT_COLUMN_WIDTH,
  OUTLINE_ID_COLUMN_WIDTH,
  OUTLINE_LABEL_COLUMN_WIDTH,
  OUTLINE_NARRATIVE_COLUMN_WIDTH,
  OUTLINE_SEQUENCE_COLUMN_WIDTH
} from "../../../../constants";
import outlineColumnIds from "../../../../constants/outlineColumnIds";
import { TableViewColumnRecord } from "./TableViewColumnRecord";

export const defaultColumnsForOutlineView = List([
  TableViewColumnRecord({
    id: outlineColumnIds.label,
    width: OUTLINE_LABEL_COLUMN_WIDTH + OUTLINE_ID_COLUMN_WIDTH
  }),
  TableViewColumnRecord({
    id: outlineColumnIds.identifier,
    width: OUTLINE_SEQUENCE_COLUMN_WIDTH
  }),
  TableViewColumnRecord({
    id: outlineColumnIds.narrative,
    width: OUTLINE_NARRATIVE_COLUMN_WIDTH
  }),
  TableViewColumnRecord({
    id: outlineColumnIds.type,
    width: OUTLINE_DEFAULT_COLUMN_WIDTH
  }),
  TableViewColumnRecord({
    id: outlineColumnIds.color,
    width: OUTLINE_DEFAULT_COLUMN_WIDTH
  }),
  TableViewColumnRecord({
    id: outlineColumnIds.start,
    width: OUTLINE_DEFAULT_COLUMN_WIDTH
  }),
  TableViewColumnRecord({
    id: outlineColumnIds.duration,
    width: OUTLINE_DEFAULT_COLUMN_WIDTH
  }),
  TableViewColumnRecord({
    id: outlineColumnIds.end,
    width: OUTLINE_DEFAULT_COLUMN_WIDTH
  })
]);
